import React from 'react';

import { IServiceBillingStatusDetailDTO } from '../../../../../../features/salesOrder/types';

interface ServiceBillingStatusDetailProps {
	billingStatusDetail?: IServiceBillingStatusDetailDTO | null;
}

const ServiceBillingStatusDetail: React.FC<ServiceBillingStatusDetailProps> = () => {
	// TODO: reactivar cuando refactoricemos facturación sin NetSuite
	return null;
};

export default ServiceBillingStatusDetail;

/*
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LaunchIcon from '@mui/icons-material/Launch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
	formatDateTimeToShowUserFromSaleOrderApiValue,
	formatDateToShowUser,
} from '../../../../../../features/common/helpers';
import routes from '../../../../../../constants/routes';

interface StatusBoxProps {
	color: string;
	icon: React.ReactNode;
	title: string;
	description?: React.ReactNode;
	syncInfo?: string | null;
}

const StatusBox: React.FC<StatusBoxProps> = ({ color, icon, title, description, syncInfo }: StatusBoxProps) => (
	<Box
		sx={{
			borderRadius: 1,
			border: (theme) => `1px solid ${theme.palette.divider}`,
			bgcolor: 'background.paper',
			p: 2,
			mt: 0.5,
			boxSizing: 'border-box',
		}}
	>
		<Stack direction="row" alignItems="center" spacing={1} mb={1}>
			<Box sx={{ color, display: 'flex', alignItems: 'center' }}>{icon}</Box>
			<Typography variant="subtitle2" sx={{ color, fontWeight: 600 }}>
				{title}
			</Typography>
		</Stack>

		{description && (
			<Typography component="div" variant="body2" color="text.secondary">
				{description}
			</Typography>
		)}

		{syncInfo && (
			<>
				<Divider sx={{ my: 1.5 }} />
				<Typography variant="caption" color="text.secondary">
					{syncInfo}
				</Typography>
			</>
		)}
	</Box>
);

interface LabelValueRowProps {
	label: string;
	value?: string | number | null;
}

const LabelValueRow: React.FC<LabelValueRowProps> = ({ label, value }: LabelValueRowProps) =>
	!value ? null : (
		<Typography variant="body2" color="text.secondary">
			<Box component="span" sx={{ fontWeight: 600 }}>
				{label}:{' '}
			</Box>
			{value}
		</Typography>
	);

const ServiceBillingStatusDetailImpl: React.FC<ServiceBillingStatusDetailProps> = ({
	billingStatusDetail,
}: ServiceBillingStatusDetailProps) => {
	const renderContent = () => {
		if (!billingStatusDetail) {
			return (
				<StatusBox
					color="#888"
					icon={<PendingIcon fontSize="small" />}
					title="Pendiente de facturación"
					description="Sin sincronizar con NetSuite"
				/>
			);
		}

		const b = billingStatusDetail;

		const syncInfo = b.lastSuccessSyncAt
			? `Última sync: ${formatDateTimeToShowUserFromSaleOrderApiValue(b.lastSuccessSyncAt)} · por ${
					b.lastActionExecutedBy
			  }`
			: null;

		if (b.hasPendingBilling) {
			return (
				<StatusBox
					color="#ed6c02"
					icon={<PendingIcon fontSize="small" />}
					title="Pendiente de facturación"
					description={<LabelValueRow label="Pendiente" value={`USD ${b.pendingBillingAmount.toFixed(2)}`} />}
					syncInfo={syncInfo}
				/>
			);
		}

		if (b.netsuiteInvoiceId) {
			const issueDateText = b.invoiceIssueDate ? formatDateToShowUser(b.invoiceIssueDate) : null;
			const dueDateText = b.invoiceDueDate ? formatDateToShowUser(b.invoiceDueDate) : null;

			return (
				<StatusBox
					color="#2e7d32"
					icon={<CheckCircleIcon fontSize="small" />}
					title="Facturado"
					description={
						<Box>
							<Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									Factura Nº {b.invoiceNumber ?? '-'}
								</Typography>

								<Stack direction="row" spacing={1}>
									{b.netsuiteInvoiceId && (
										<Tooltip title="Ver PDF de la factura">
											<IconButton
												size="small"
												onClick={() =>
													window.open(
														routes.salesOrder.saleOrderInvoiceDetail.replace(':invoiceId', String(b.netsuiteInvoiceId)),
														'_blank',
													)
												}
											>
												<InsertDriveFileIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}

									{b.netsuiteInvoiceUrl && (
										<Tooltip title="Ver detalle de la factura en NetSuite">
											<IconButton size="small" onClick={() => window.open(b.netsuiteInvoiceUrl || '', '_blank')}>
												<LaunchIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}
								</Stack>
							</Stack>

							<Stack spacing={0.3}>
								<LabelValueRow label="Fecha emisión" value={issueDateText} />
								<LabelValueRow label="Fecha vencimiento" value={dueDateText} />
								<LabelValueRow label="Términos de pago" value={b.invoicePaymentTerms} />
								<LabelValueRow label="Tipo de documento" value={b.invoiceDocumentType} />
							</Stack>
						</Box>
					}
					syncInfo={syncInfo}
				/>
			);
		}

		return (
			<StatusBox
				color="#0288d1"
				icon={<InfoOutlinedIcon fontSize="small" />}
				title="Sin pendiente de facturar"
				description="Monto no requería factura"
				syncInfo={syncInfo}
			/>
		);
	};

	return (
		<Box
			mt={2}
			sx={{
				width: '100%',
				maxWidth: '100%',
				boxSizing: 'border-box',
			}}
		>
			<Stack direction="row" alignItems="center" spacing={1} mb={1}>
				<InfoOutlinedIcon fontSize="small" color="action" />
				<Typography variant="h6" color={'Grey'}>
					Información de facturación
				</Typography>
			</Stack>

			{renderContent()}
		</Box>
	);
};
*/
